import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild} from '@angular/core';
import {ModalParams} from '../../shared/modal-params';
import {ModalService} from '../../shared/services/modal.service';
import {of, Subscription} from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnDestroy {

  defaultParams: ModalParams = {
    title: null,
    content: null,
    closeButton: {
      displayed: true,
      text: 'Close',
      type: 'white'
    },
    validateButton: {
      displayed: true,
      text: 'Ok',
      type: 'primary'
    },
    beforeResolve: () => of({}),
  };
  params: ModalParams;

  opened = false;

  disabled = false;

  bodyTemplate: TemplateRef<any>;

  openSubscription: Subscription;

  triggerResolutionSubscription: Subscription;

  triggerCloseSubscription: Subscription;

  @ViewChild('fade')
  fade: ElementRef;

  @Input()
  private orphan: boolean;
  constructor(private modalService: ModalService, private renderer: Renderer2) {
    this.reset();

    if (!this.orphan) {
      this.openSubscription = modalService.getOpenObservable()
        .pipe(filter(p => !p.fullSize))
        .subscribe(p => {
          this.open(p);
        });

      this.triggerResolutionSubscription = modalService.getTriggerResolutionObservable()
        .pipe(filter(_ => this.opened))
        .subscribe(() => {
          this.resolve(this.params.validateButton.action);
        });

      this.triggerCloseSubscription = modalService.getTriggerCloseObservable()
        .pipe(filter(_ => this.opened))
        .subscribe(() => {
          this.close(this.params.closeButton.action);
        });
    }
  }

  ngOnInit() {
  }

  reset() {
    this.disabled     = false;
    this.bodyTemplate = null;
    this.params       = { ...this.defaultParams };
  }

  open(p: ModalParams) {
    this.params       = {
      ...this.defaultParams,
      ...p,
      closeButton: { ...this.defaultParams.closeButton, ...p.closeButton },
      validateButton: { ...this.defaultParams.validateButton, ...p.validateButton }
    };
    this.opened       = true;
    this.bodyTemplate = this.params.content;
    this.renderer.addClass(document.body, 'modal-open');
  }

  close(btnAction: (...args: any[]) => any) {
    if (btnAction) {
      btnAction();
    }
    this.opened = false;
    this.renderer.removeClass(document.body, 'modal-open');

    const emitter = this.modalService.getResolveEmitter();

    if (emitter && !this.orphan) {
      emitter.complete();
    }

    this.reset();
  }

  resolve(btnAction: (...args: any[]) => any) {
    this.disabled = true;
    this.params.beforeResolve()
      .pipe(take(1))
      .subscribe(() => {
        if (!this.orphan) {
          this.modalService.getResolveEmitter().next();
        }
        this.close(btnAction);
      }, () => {
        this.disabled = false;
      });
  }

  ngOnDestroy() {
    if (!this.orphan) {
      this.openSubscription.unsubscribe();
      this.triggerResolutionSubscription.unsubscribe();
    }
  }

  handleClick(event: any, params, disabled) {
    if (!params.disableModalCloseOutsideClick && !disabled && event.target === this.fade.nativeElement) {
      this.close(params.closeButton.action);
    }
  }

  getZIndex() {
    return this.params.zIndex ? 'z-index: ' + this.params.zIndex + '; display: block;' : null;
  }
}
